import { ArrowBack } from '@mui/icons-material';
import {
  Button,
  Divider,
  List,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';
import MuiDrawer from '@mui/material/Drawer';
import { styled } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { configItems } from '../configurations/tableData';
import { getCurrentProject } from '../../modules/project';

const drawerWidth = 220;

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  '& .MuiDrawer-paper': {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: 'border-box',
    backgroundColor: theme.palette.background.paper,
    overflowX: 'hidden',
  },
}));

const ADMIN_ONLY_TABS = new Set(['ai-config']);
const ConfigSidebar = ({ selectedTab, setSelectedTab, user }) => {
  const { projectId } = useParams();
  const [currentProject, setCurrentProject] = useState(null);
  const isAdminRole = ['org-admin', 'org-manager', 'admin'].includes(user?.role);
  const fetchCurrentProject = async () => {
    if (projectId) {
      const response = await getCurrentProject(projectId);
      setCurrentProject(response);
    }
  };
  useEffect(() => {
    if (projectId) {
      fetchCurrentProject();
    }
  }, [projectId]);

  const handleTabClick = (id) => {
    setSelectedTab(id);
  };

  return (
    <Drawer
      variant="permanent"
      open={true}
      sx={{
        mt: '64px',
        backgroundColor: '#fff',
      }}>
      <div>
        <Button
          component={Link}
          to={`/project/${projectId}/dashboard`}
          variant="link"
          fullWidth
          sx={{
            p: 1,
            my: 1,
          }}
          disableRipple
          startIcon={<ArrowBack />}>
          Back to Project
        </Button>
        {currentProject && (
          <Typography
            variant="subtitle1"
            color="text.primary"
            sx={{
              fontWeight: 600,
              textAlign: 'center',
              whiteSpace: 'break-spaces',
            }}>
            {currentProject?.name || ''}
          </Typography>
        )}
      </div>
      <Divider sx={{ my: 1, borderColor: 'black' }} />
      <List component="nav">
        {Object.keys(configItems).map((category) => (
          <React.Fragment key={category}>
            <Typography
              variant="subtitle1"
              color="#fff"
              align="center"
              sx={{ fontWeight: 'bold', bgcolor: '#1b3f87'}}>
              {category.charAt(0).toUpperCase() + category.slice(1)}
            </Typography>

            {configItems[category]
              .filter((item) => !ADMIN_ONLY_TABS.has(item.id) || isAdminRole) 
              .map((item) => (
                <Link
                  key={item.id}
                  to={`/project/${projectId}/configurations?tab=${item.id}`}
                  style={{ textDecoration: 'none', color: 'inherit' }}>
                  <ListItemButton
                    selected={selectedTab === item.id}
                    onClick={() => handleTabClick(item.id)}
                    sx={{
                      pl: 2,
                    '&:hover': {
                      backgroundColor: 'rgba(0, 0, 0, 0.08)',
                    },
                      borderRadius: 1,
                    }}>
                    <ListItemText primary={item.label} sx={{ m: 0 }} />
                  </ListItemButton>
                </Link>
              ))}
            <Divider />
          </React.Fragment>
        ))}
      </List>
    </Drawer>
  );
};

export default ConfigSidebar;
